import React, { useEffect, useState } from 'react';
import Avatar from 'src/components/base/Avatar/Avatar';
import { QuestionsUniqueKeys } from 'src/containers/QuestionnaireParent/QuestionnaireEnum';
import { useSelector } from 'react-redux';
import { getPicture } from 'src/redux/services/commonServices';

interface Question {
  unique_key: string;
  choices: {
    value: string;
    selected?: boolean;
  }[];
}

interface Props {
  questions: Question[];
}

export const CustomPracticeAddress: React.FC<Props> = ({ questions }) => {
  const getQuestionValue = (uniqueKey: string) => {
    const question = questions.find(q => q.unique_key === uniqueKey);

    return question?.choices?.[0]?.value || '';
  };

  const getSelectedState = (uniqueKey: string) => {
    const question = questions.find(q => q.unique_key === uniqueKey);
    const selectedChoice = question?.choices?.find(c => c.selected);

    return selectedChoice?.value || '';
  };

  const isDirectoryPlatform = useSelector(
    (state: any) => state?.configuration?.isDirectoryPlatform === 'true',
  );

  const address = getQuestionValue(
    QuestionsUniqueKeys.inPersonOfficeAddressQuestion,
  );
  const apartment = getQuestionValue(
    QuestionsUniqueKeys.inPersonOfficeApartmentQuestion,
  );
  const city = getQuestionValue(QuestionsUniqueKeys.inPersonOfficeCityQuestion);
  const state = getSelectedState(
    QuestionsUniqueKeys.inPersonOfficeStateQuestion,
  );
  const zipCode = getQuestionValue(
    QuestionsUniqueKeys.inPersonOfficeZipCodeQuestion,
  );
  const pictureRawValue = getQuestionValue(
    QuestionsUniqueKeys.inPersonOfficePictureQuestion,
  );
  const [finalPhotoUrl, setFinalPhotoUrl] = useState('');

  useEffect(() => {
    const resolveImage = async () => {
      if (!pictureRawValue) {
        setFinalPhotoUrl('');

        return;
      }

      if (!isDirectoryPlatform) {
        setFinalPhotoUrl(decodeURIComponent(pictureRawValue));

        return;
      }

      if (pictureRawValue.startsWith('http')) {
        setFinalPhotoUrl(pictureRawValue);
      } else {
        const imageData = await getPicture(pictureRawValue);

        setFinalPhotoUrl(imageData || '');
      }
    };

    resolveImage();
  }, [pictureRawValue, isDirectoryPlatform]);

  return (
    <div className="practice-profile__in-person-ofc  therapist-profile__in-person-ofc">
      <div className="flex-shrink-0">
        <Avatar photoUrl={finalPhotoUrl} fullName={apartment} />
      </div>
      <div className="practice-profile__in-person-ofc-address  therapist-profile__in-person-ofc-address">
        <p>{address}</p>
        {apartment && <p>{apartment}</p>}
        <p>
          {city}, {state} {zipCode}
        </p>
      </div>
    </div>
  );
};
